import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
//import {  Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'

export default {
	name: 'shipment-summary',
	components: {
		BasicSelect,
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			pageCountrule: 0,
			pageCount: 0,
			pageNo: 0,
			shippingDetails: {},
			showModal: false,
			isLoadingSearch: false,
			shippingID: '',
			transactions: [],
			shippingIDErrorMSG: '',
			isEmpty: 0,
		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
		toFixedNum: function(val) {
      if (val && val > 0) {
        return Number(parseFloat(val).toFixed(2));
      } else {
        return 0;
      }
      // var with2Decimals = val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
      // return  with2Decimals
    },
	},
	mounted() {

	},
	methods: {
		showModalOnClick(shippingDetails) {
			this.transactions = shippingDetails.Transactions
			this.showModal = true
		},
		closeModal() {
			this.showModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		getBagDetailsByShippingID() {
			if (this.shippingID == '') {
				this.shippingIDErrorMSG = 'Enter Shipping ID';
				return false;
			}
			this.shippingIDErrorMSG = '';
			this.isLoadingSearch = true;
			this.input = ({
				"ShippingID": this.shippingID
			})
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'getShipmentTransactionDetails',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoadingSearch = false;
					if (result.data.ResultCode == 100) {
						this.shippingDetails = result.data.ResponseData;
						this.isEmpty = Object.keys(this.shippingDetails).length;
						let totalRows = result.data.length
						if (totalRows < 10) {
							this.pageCountrule = 1
						} else {
							this.pageCountrule = Math.ceil(totalRows / 10);
						}
					} else {
						this.isEmpty = 0;
						this.shippingDetails = [];
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					console.error(error)
				})
		},
		onSubmitSearch: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
				// this.$alertify.success("your message");
			}).catch(() => {
				console.log('errors exist')
				//this.$alertify.error("your message")
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/ShipmentSummary/ShipmentSummary.js